import { MatrixCellInterface, MatrixQuestInterface } from "@swivl-mono/types";
import * as React from "react";
import { FaCircle } from "react-icons/fa";

import { WorkflowsJourney } from "../../../../../Models/Quests/Quests.Model";
import MatrixView from "../../MatrixView";
import MatrixAddColumnOrRow from "./MatrixAddColumnOrRow";
import "./MatrixCell.scss";
import MatrixQuestLabel from "./MatrixQuestLabel";
import MatrixSpacer from "./MatrixSpacer";
import MatrixValueLabel from "./MatrixValueLabel";

interface Props {
  delegate: MatrixView;
  item: MatrixCellInterface;
  focus: { x: any; y: any };
  setShowMenu(x?, y?, keepFocus?, side?); // side is optional and just for spacer variable labels
  showMenu: { x?: number; y?: number; side?: string };
  setFocus(x?, y?);
  x: number;
  y: number;
  workflows: WorkflowsJourney[];
  matrix: MatrixQuestInterface;
  canEdit: boolean;
}
export default class MatrixCellView extends React.Component<Props> {
  constructor(props) {
    super(props);

    this.setQuest = this.setQuest.bind(this);

    this.toggleMenu = this.toggleMenu.bind(this);
    this.onClick = this.onClick.bind(this);
    // this.onHover        = this.onHover.bind(this)
    // this.onBlur         = this.onBlur.bind(this)

    this.addNewValue = this.addNewValue.bind(this);
    this.addNotSet = this.addNotSet.bind(this);
    this.addOther = this.addOther.bind(this);
    this.deleteColumnOrRow = this.deleteColumnOrRow.bind(this);
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.item &&
      this.props.item.type === "value" &&
      this.props.focus &&
      this.props.focus.x === this.props.x &&
      this.props.focus.y === this.props.y &&
      ((prevProps.focus && prevProps.focus.x != this.props.x) || prevProps.focus.y != this.props.y)
      // this.props.item && this.props.item.type === "value"
      //
    ) {
      const field = document.getElementById("val_" + this.props.x + "_" + this.props.y + "_first_input");
      if (field) {
        field.focus();
      }
    }
  }
  setQuest(questSlug) {
    this.props.setShowMenu(null, null, true);
    this.props.delegate.setQuest(questSlug, this.props.x, this.props.y);
  }

  addNewValue() {
    this.props.delegate.addValue("New Value", this.props.x, this.props.y);
  }
  addNotSet() {
    this.props.delegate.addValue("SPECIAL_NOT_SET", this.props.x, this.props.y);
  }
  addOther() {
    this.props.delegate.addValue("SPECIAL_OTHER", this.props.x, this.props.y);
  }
  deleteColumnOrRow() {
    this.props.setShowMenu(null, null, false);

    if (this.props.item.axis === "x") {
      this.props.delegate.deleteColumnOrRow("column", this.props.x);
    } else {
      this.props.delegate.deleteColumnOrRow("row", this.props.y);
    }
  }

  toggleMenu(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (this.props.showMenu && this.props.showMenu.x === this.props.x && this.props.showMenu.y === this.props.y) {
      this.props.setShowMenu(null, null);
    } else {
      this.props.setShowMenu(this.props.x, this.props.y);
    }
  }

  onClick() {
    // if (this.props.focus && this.props.focus.x === this.props.x && this.props.focus.y === this.props.y) {
    //   if (this.props.showMenu && this.props.showMenu.x === this.props.x && this.props.showMenu.y === this.props.y ) {
    //      // Dont clear if the menu is up.
    //      return
    //    }
    //   this.props.setFocus(null,null)
    // } else {
    this.props.setFocus(this.props.x, this.props.y);
    // }
  }
  // onHover() { this.props.cellHovered(this.props.x,this.props.y) }
  // onBlur() { this.props.cellBlur(this.props.x,this.props.y) }

  render() {
    const item: any = this.props.item;
    if (item.type === "empty") {
      return <td />;
    }
    const showMenu = this.props.showMenu && this.props.showMenu.x === this.props.x && this.props.showMenu.y === this.props.y;

    let tdClassName = "MatrixCell";

    let content;
    let className = "cell";
    let focused = false;
    if (this.props.focus && this.props.focus.x === this.props.x && this.props.focus.y === this.props.y) {
      className += " focused";
      tdClassName += " focused";
      focused = true;
    }

    if (item.type === "add" && this.props.canEdit) {
      return (
        <td className="addTd">
          <MatrixAddColumnOrRow item={item} focus={this.props.focus} x={this.props.x} y={this.props.y} delegate={this.props.delegate} />
        </td>
      );
    } else if (item.type === "spacer") {
      className += " spacer";
      tdClassName += " spacer";
      content = (
        <MatrixSpacer
          item={item}
          x={this.props.x}
          y={this.props.y}
          delegate={this.props.delegate}
          showMenu={this.props.showMenu}
          setShowMenu={this.props.setShowMenu}
          canEdit={this.props.canEdit}
        />
      );
    } else if (item.type === "value") {
      tdClassName += " value";
      className += " value";
      var hasFirstInput = false;
      const values = item.values.map((val, valIndex) => {
        let inputId = "val_" + this.props.x + "_" + this.props.y + "_" + valIndex;

        if (!hasFirstInput && val != "SPECIAL_OTHER" && val != "SPECIAL_NOT_SET") {
          hasFirstInput = true;
          inputId = "val_" + this.props.x + "_" + this.props.y + "_first_input";
        }
        return (
          <MatrixValueLabel
            item={item}
            key={"val)" + this.props.x + "_" + this.props.y + "_" + valIndex}
            value={val}
            x={this.props.x}
            y={this.props.y}
            index={valIndex}
            canDelete={item.values.length > 1}
            delegate={this.props.delegate}
            focused={focused}
            inputId={inputId}
            canEdit={this.props.canEdit}
          />
        );
      });
      content = values;
    } else if (item.type === "quest") {
      className += " quest";

      content = (
        <MatrixQuestLabel
          item={item}
          key={"quest_" + this.props.x + "_" + this.props.y}
          showMenu={showMenu}
          toggleMenu={this.toggleMenu}
          setQuest={this.setQuest}
          workflows={this.props.workflows}
          setShowMenu={this.props.setShowMenu}
          canEdit={this.props.canEdit}
        />
      );
    }

    var valueMenuButton, valueMenu;
    if (item.type === "value") {
      if (showMenu && item.type == "value") {
        tdClassName += " showingValueMenu";
        var deleteColumnOrRowButton;
        if ((item.axis === "x" && this.props.matrix.data.data[0].length > 2) || (item.axis === "y" && this.props.matrix.data.data.length > 2)) {
          const deleteText = item.axis === "x" ? "Delete Column" : "Delete Row";
          deleteColumnOrRowButton = (
            <div className="valueMenuOption" onClick={this.deleteColumnOrRow}>
              {deleteText}
            </div>
          );
        }

        valueMenu = (
          <div className="valueMenu">
            <div className="valueMenuOption" onClick={this.addNewValue}>
              Add Value{" "}
            </div>
            <div className="valueMenuOption" onClick={this.addNotSet}>
              Add "Not Set"
            </div>
            <div className="valueMenuOption" onClick={this.addOther}>
              Add "Other"{" "}
            </div>
            {deleteColumnOrRowButton}
          </div>
        );
      }

      valueMenuButton = this.props.canEdit ? (
        <div className="valueMenuButton">
          <div className="valueMenuButtonWrapper" onClick={this.toggleMenu}>
            <FaCircle />
            <FaCircle />
            <FaCircle />
          </div>
          {valueMenu}
        </div>
      ) : null;
    }

    return (
      <td className={tdClassName}>
        {valueMenuButton}
        <div className={className} onClick={this.onClick}>
          {content}
        </div>
      </td>
    );
  }
}
